// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"6106d67e","100":"ab5d96ce","284":"4b5c98d9","443":"9f44402a","453":"04a334ca","699":"fdc15075","722":"eaa35db4","885":"b935f924"}[chunkId] + ".chunk.js";
};